import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import WaAdminShell from '../../components/admin/whatsapp/WaAdminShell';
import WaLogThread from '../../components/admin/whatsapp/WaLogThread';
import { fetchWaSession, fetchWaTranscript, forceHandoff, opsMonitorUrl } from '../../utils/adminWhatsapp';
import { stageBadgeClass, stageLabel, stateBadgeClass, stateLabel } from '../../components/admin/whatsapp/waStageLabels';

export default function WhatsAppSessionTranscript() {
  const { sessionId } = useParams();
  const [session, setSession] = useState(null);
  const [messages, setMessages] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    fetchWaSession(sessionId).then((r) => setSession(r.session)).catch(() => setSession(null));
    fetchWaTranscript(sessionId).then((r) => setMessages(r.messages || [])).catch(() => setMessages([]));
  }, [sessionId]);

  const cart = session?.booking_cart || {};
  const acfId = session?.acf_booking_id;

  return (
    <WaAdminShell title="Session transcript" subtitle={session?.phone_masked || sessionId}>
      {session?.state === 'agent_mode' && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-800">
          Customer is in human agent mode — bot is silent.
        </div>
      )}
      <div className="flex flex-wrap gap-2 mb-4">
        <Link to="/admin/whatsapp" className="text-sm text-[#659A9B]">← Dashboard</Link>
        {acfId && (
          <a href={opsMonitorUrl(acfId)} className="text-sm bg-[#1B375B] text-white px-3 py-1 rounded-lg">
            Ops Monitor
          </a>
        )}
        <button
          type="button"
          className="text-sm text-red-600 border border-red-200 px-3 py-1 rounded-lg"
          onClick={() => forceHandoff(sessionId).then(() => window.location.reload())}
        >
          Force handoff
        </button>
      </div>
      {session && (
        <div className="bg-white border rounded-xl p-4 mb-4 text-sm grid md:grid-cols-2 gap-2">
          <p><strong>Name:</strong> {session.customer_name}</p>
          <p>
            <span className={`text-xs px-2 py-0.5 rounded-full ${stageBadgeClass(session.stage)}`}>{stageLabel(session.stage)}</span>
            {' '}
            <span className={`text-xs px-2 py-0.5 rounded-full ${stateBadgeClass(session.state)}`}>{stateLabel(session.state)}</span>
          </p>
          <p><strong>Route:</strong> {cart.origin_iata || '—'} → {cart.destination_iata || '—'}</p>
          <p><strong>Updated:</strong> {session.updated_at?.slice(0, 19)}</p>
        </div>
      )}
      <div className="bg-white border rounded-xl min-h-[50vh]">
        <WaLogThread messages={messages} expandedId={expanded} onToggle={setExpanded} />
      </div>
    </WaAdminShell>
  );
}
